import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectVerifiableDevicesByWiseBox } from 'selectors/devices';
import StatusTable from '../StatusTable';

const WiseBoxVerification = ({ deviceId }) => {
    const selectedDevices = useMemo(() => selectVerifiableDevicesByWiseBox(deviceId), [deviceId]);
    const devices = useSelector(selectedDevices);

    return <StatusTable devices={devices}/>;
};

export default WiseBoxVerification;
